import React from 'react'
import { isNil } from 'lodash'
import { CrudEventEnum, OrganisationMetaDetail } from 'api'
import { Locale, Translation } from 'locale'
import { OnOffButtons } from 'view/components/buttons'
import { TypedContext, StandardGridColumnId, TypedCellRendererParams, TypedValueGetterParams } from 'view/components/datagrid'
import { TradeSplitColumnDefs, TradeSplitColumnId, tradeSplitGridOptions } from 'view/routes/tradeSplit/TradeSplitGrid/TradeSplitGridModel'

const tradeSplitRenderer = React.forwardRef(
  (
    params: TypedCellRendererParams<
      OrganisationMetaDetail,
      unknown,
      TypedContext<OrganisationMetaDetail> & {
        disabled: boolean
        onUpdateTradeSplit: (...args: any[]) => void
      }
    >,
    ref: React.Ref<any>
  ) => {
    const { context, node } = params

    if (node.group) {
      return null
    }

    return (
      <OnOffButtons
        ref={ref}
        on={node.data.organisationMeta.splitTrades}
        onLabel={Translation.UC_ON}
        offLabel={Translation.UC_OFF}
        onChange={on => !isNil(node.id) && context.onUpdateTradeSplit(node.id, node.data, on)}
        disabled={params.context.disabled || !node.data.availableEvents.includes(CrudEventEnum.UPSERT)}
      />
    )
  }
)

const TRADE_SPLIT = {
  colId: TradeSplitColumnId.TRADE_SPLIT,
  headerName: Locale.translate(Translation.TC_SPLIT_TRADES),
  valueGetter: (params: TypedValueGetterParams<OrganisationMetaDetail>) => params.data?.organisationMeta.splitTrades,
  cellRenderer: tradeSplitRenderer,
  width: 120,
  filter: 'agSetColumnFilter'
}

export const TradeSplitPanelColumnDefs = TradeSplitColumnDefs.filter(
  colDef => colDef.colId !== StandardGridColumnId.CHECKBOX && colDef.colId !== TradeSplitColumnId.MY_FIRM
).map(colDef => {
  if (colDef.colId === TradeSplitColumnId.TRADE_SPLIT) {
    return TRADE_SPLIT
  }

  return colDef
})

export const tradeSplitPanelGridOptions = tradeSplitGridOptions
